import React from 'react'
import AutoSwipeBanner from './AutoSwipeBanner'
import useBackgroundImage from '../../hooks/useBackgroundImage'
import { getBannerBackgroundStyle } from '../../utils/backgroundStyles'
import { useSelector } from 'react-redux'

const Banner = () => {
    const backgroundImage = useBackgroundImage();
    const { banners, status } = useSelector((state) => state.banner);

    const hasBackground = Boolean(backgroundImage);
    
    // Extract banners from the new nested structure
    const bannerList = React.useMemo(() => banners?.banner || banners || [], [banners]);
    
    // Hide the banner section if no banners available (only when status is succeeded or failed)
    if ((status === 'succeeded' || status === 'failed') && (!bannerList || bannerList.length === 0)) {
        return null;
    }

    return (
        <section 
            className={`header-banner w-full ${hasBackground ? 'bg-yellow-50' : ''} min-h-[240px] sm:min-h-[240px] md:min-h-[520px] lg:min-h-[600px] xl:min-h-[680px] flex flex-col justify-center py-2 sm:py-3 md:py-5 lg:py-8 ${hasBackground ? 'pt-16 sm:pt-14 md:pt-16 lg:pt-20 xl:pt-24' : 'pt-20 sm:pt-18 md:pt-20 lg:pt-24 xl:pt-28'}`}
            style={hasBackground ? getBannerBackgroundStyle(backgroundImage) : { backgroundImage: 'none', backgroundColor: 'transparent' }}
        >
            {/* Auto Swipe Banner */}
            <div className="w-full max-w-screen-xl mx-auto flex justify-center md:justify-start items-center mb-1 sm:mb-2 md:mb-4 px-2 sm:px-3 md:px-6">
                <AutoSwipeBanner />
            </div>
            
        </section>
    )
}

export default Banner
